// ======================================================================
// File Name       : CourseEditGroupContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as courseActions from '../../actions/CourseAction';
import * as ModalAction from '../../actions/ModalAction';
import * as userAction from '../../actions/UserAction';
import SelectGroupDlg from '../../components/course/SelectGroupDialog';
import SelectGroupListDlg from '../../components/course/SelectGroupListDialog';
import DateTimeMinMax from '../../components/DateTimeMinMax';
import DateTimeWithValidate from '../../components/DateTimeWithValidate';
import ModalWrapper from '../../components/modal/ModalWrapper';
import TableHead from '../../components/TableHead';
import { DEFAULT_DATE_FORMAT_SHORT_DETAIL, MODE, RETURN_MAX_NUM_1000 } from '../../constants';
import { REDIRECT_MODAL } from '../../constants/CourseConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { WRONG_ATTENDING_DATE_TXT } from '../../utils/index';


class CourseEditGroupContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showTreeGroup: false,
      showListGroup: false,
      indexGroup: null,
      isAllowShowSearchMessage: false,
      isInit: true,
      isAdminGroup: false,
    };

    this.handleBackBtn = this.handleBackBtn.bind(this);
    this.handleOkBtn = this.handleOkBtn.bind(this);
    this.validation = this.validation.bind(this);
    this.showSelectGroupDlg = this.showSelectGroupDlg.bind(this);
    this.okSelectGroupDlg = this.okSelectGroupDlg.bind(this);
    this.cancelSelectGroupDlg = this.cancelSelectGroupDlg.bind(this);
    this.handlePeriodTimeChange = this.handlePeriodTimeChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, userInfo, course } = this.props;
    const { editType, editingCourse } = course;
    // Check user login has group
    dispatch(userAction.getUserGroupRelation(userInfo.userSecernId, true)).then((result) => {
      const { recordNum } = result.data;
      if (recordNum > 0) {
        this.setState({
          isAdminGroup: true,
        });
      } else {
        this.setState({
          isAdminGroup: false,
        });
      }
    });
    this.props.dispatch(userAction.getGroupListAll()); //STEP10.0.0
  }

  getModalOptions() {
    return {
      title: 'コースに紐付けるグループを選択してください',
      footerBtns: null,
      dialogClassName: 'course-edit-group-dialog',
      bsSize: 'lg',
    };
  }

  componentWillUnmount() {
    this.props.dispatch(userAction.removedDataUserHasGroupAndRole());
  }

  handleOkBtn() {
    if (!this.validation()) {
      return;
    }
    const { dispatch, modalId, course } = this.props;
    const { editType, editingCourse } = course;
    const { imageFileSelectType } = editingCourse;
    if (editType === MODE.EDIT_MODE) {
      dispatch(courseActions.changeData());
    }

    dispatch(ModalAction.openModal(REDIRECT_MODAL[modalId].OK));
  }

  handleBackBtn() {
    const { dispatch, modalId, course } = this.props;
    const { editingCourse } = course;
    const { dataAffiliationType } = editingCourse;

    dispatch(ModalAction.openModal(REDIRECT_MODAL[modalId].CANCEL));
  }

  /**
   * Show select group dialog
   */
  showSelectGroupDlg() {
    const { isAdminGroup } = this.state;
    const { userInfo, dispatch } = this.props;
    if (isAdminGroup) {
      this.setState({ showListGroup: true });
    } else {
      this.setState({ showTreeGroup: true });
    }
  }

  /**
   * Handle event when click on キャンセル of select group dialog
   */
  cancelSelectGroupDlg() {
    const { isAdminGroup } = this.state;
    if (isAdminGroup) {
      this.setState({ showListGroup: false });
    } else {
      this.setState({ showTreeGroup: false });
    }
  }

  /**
   * Handle event when click on OK of group dialog
   *
   * @param {*} group
   */
  okSelectGroupDlg(group) {
    const { dispatch } = this.props;
    this.setState(
      {
        showTreeGroup: false,
        showListGroup: false,
      },
      () => {
        dispatch(courseActions.addCourseGroupRelation(group));
      },
    );
  }

  removeCourseGroup(groupSecernId) {
    const { dispatch } = this.props;
    dispatch(courseActions.removeCourseGroupRelation(groupSecernId));
  }

  removeAllCourseGroup(isAdminHasCourseRelation) {
    const { dispatch } = this.props;
    dispatch(courseActions.removeAllCourseGroupRelation(isAdminHasCourseRelation));
  }

  handlePeriodTimeChange(index, name, mDate) {
    const { dispatch } = this.props;
    // #7230 START
    const mDateTxt = mDate && mDate.format ? mDate.format(mDate.format) : mDate;
    // #7230 END
    dispatch(courseActions.editGroupPeriodTime(index, { [name]: mDateTxt }));
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    this.refsToValidate = [];
    const { authority, course, user, isAdminHasCourseRelation } = this.props;
    const { selectedCourseGroupRelationList, recordNumGroupCourseRelation, editType } = course;
    const { userGroupRelationListUserLoging, groupInfoAll } = user;
    const { isAdminGroup } = this.state;
    let groupList = [];
    if (user.allGroup && user.allGroup.length) {
      groupList = user.allGroup;
    }
    const recordNumGroupCourseRelations = recordNumGroupCourseRelation || 0;
    const isShowMessageGroupMaxRecord = recordNumGroupCourseRelations > RETURN_MAX_NUM_1000;
    const thead = [
      { title: 'ユーザーグループ名', sortBy: null },
      { title: '有効期限開始日時', sortBy: null },
      { title: '有効期限終了日時', sortBy: null },
      { title: '操作', sortBy: null, width: 110 },
    ];
    const groupListObj = groupList && groupList.reduce((obj, cur) => {
      obj[cur.groupSecernId] = cur;
      return obj;
    }, {});

    let dataTable = null;
    if (selectedCourseGroupRelationList && selectedCourseGroupRelationList.length) {
      dataTable = selectedCourseGroupRelationList.map((group, index) => {
        // Check to disable button edit of course group relation
        const isDisableEditCourseGroup = isAdminHasCourseRelation && !group.addNew;
        let groupName = '';
        if (Object.keys(groupListObj).length && groupListObj[group.groupSecernId]) {
          groupName = groupListObj[group.groupSecernId].groupName;
        }
        return (
          <tr key={index}>
            <td>{groupName}</td>
            <td>
              {/* #7230 START */}
              <DateTimeWithValidate
                dateFormat={DEFAULT_DATE_FORMAT_SHORT_DETAIL}
                value={group.attendingPeriodFrom}
                onChange={(mDate) =>
                  this.handlePeriodTimeChange(
                    index,
                    'attendingPeriodFrom',
                    mDate ? mDate.format(DEFAULT_DATE_FORMAT_SHORT_DETAIL) : '',
                  )
                }
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                disabled={isDisableEditCourseGroup || isShowMessageGroupMaxRecord}
                className={!isDisableEditCourseGroup && !isShowMessageGroupMaxRecord ? '' : 'cursor-disable calendar-disable'}
                showTime
              />
              {/* #7230 END */}
            </td>
            <td>
              {/* #7230 START */}
              <DateTimeWithValidate
                dateFormat={DEFAULT_DATE_FORMAT_SHORT_DETAIL}
                value={group.attendingPeriodTo}
                onChange={(mDate) =>
                  this.handlePeriodTimeChange(
                    index,
                    'attendingPeriodTo',
                    mDate ? mDate.format(DEFAULT_DATE_FORMAT_SHORT_DETAIL) : '',
                  )
                }
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                disabled={isDisableEditCourseGroup || isShowMessageGroupMaxRecord}
                className={!isDisableEditCourseGroup && !isShowMessageGroupMaxRecord ? '' : 'cursor-disable calendar-disable'}
                showTime
              />
              {/* #7230 END */}
              <DateTimeMinMax
                dateFrom={group.attendingPeriodFrom}
                dateTo={group.attendingPeriodTo}
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
                wrongPeriodTxt={WRONG_ATTENDING_DATE_TXT}
              />
            </td>
            <td className="text-center">
              {!isDisableEditCourseGroup && !isShowMessageGroupMaxRecord && (
                <i
                  role="button"
                  onClick={this.removeCourseGroup.bind(this, index)}
                  className="bi bi-trash margin-top-10"
                />
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <ModalWrapper
        temporaryHide={this.state.showTreeGroup ? 'hidden' : ''}
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <Form>
          {!isShowMessageGroupMaxRecord &&
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-clear margin-top-20">
              <Col sm={3} className="padding-left-clear margin-top-10">
                ユーザーグループ名
              </Col>
              <Col sm={3}>
                <Button variant="primary" className="btn-96" onClick={this.showSelectGroupDlg}>
                  グループ選択
                </Button>
              </Col>
            </Col>
          </Form.Group>
          }
          <Form.Group className="form-info">
            <Col sm={12} className="msg-error bold padding-left-right-clear">
              {isShowMessageGroupMaxRecord ? MessageTemplate.MSG_RESULT_OVER_MAX_RETURN_NUM : ''}
            </Col>
            <Col sm={12} className={isShowMessageGroupMaxRecord ? 'padding-left-clear padding-right-clear' : 'padding-left-clear padding-right-clear margin-top-50'}>
              <Col sm={12} className={isShowMessageGroupMaxRecord ? 'padding-left-clear margin-top-10 margin-bottom-10' : 'padding-left-clear margin-top-15'}>
                紐付け対象ユーザーグループ
              </Col>
              {editType !== MODE.NEW_MODE &&
                <Col sm={12} className="padding-left-right-clear margin-top-10 margin-bottom-10 textColorRed">
                  ※新しいレイアウトで設定したユーザーグループ紐づけは、古いレイアウトでは表示されません
                </Col>
              }
              { !isShowMessageGroupMaxRecord && <Col sm={12} className="padding-right-clear margin-bottom-10">
                <Button variant="default" className="float-end" onClick={this.removeAllCourseGroup.bind(this, isAdminHasCourseRelation)}>
                  ユーザーグループ一括削除
                </Button>
              </Col>}
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Table striped hover>
              <thead>
                <TableHead data={thead} />
              </thead>
              <tbody>{dataTable}</tbody>
            </Table>
          </Form.Group>
          <Form.Group className="form-info margin-top-50">
            <Col sm={12} className="text-center padding-top-10">
              <Button
                style={{ marginRight: '5px' }}
                onClick={this.handleBackBtn}
                className="btn-96"
                variant='default'
              >
                {'戻る'}
              </Button>
              <Button variant="primary" className="btn-96" onClick={this.handleOkBtn}>
                {'OK'}
              </Button>
            </Col>
          </Form.Group>
          <SelectGroupDlg
            showModal={this.state.showTreeGroup}
            selectedGroupList={selectedCourseGroupRelationList}
            selectedGroup={selectedCourseGroupRelationList}
            groupList={groupList}
            onCancel={this.cancelSelectGroupDlg}
            onOK={this.okSelectGroupDlg}
            isCheckBox
          />
          {this.state.showListGroup && (
            <SelectGroupListDlg
              showModal={this.state.showListGroup}
              selectedGroup={selectedCourseGroupRelationList}
              groupList={groupList}
              userInfo={this.props.userInfo}
              onCancel={this.cancelSelectGroupDlg}
              onOK={this.okSelectGroupDlg}
            />
          )}
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authority, group, course, authed, user, container } = state;
  const { groupList } = group;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  const { isAdminHasCourseRelation } = container;
  return {
    course,
    groupList,
    authority: authority.authorityInfo,
    userInfo,
    user,
    isAdminHasCourseRelation,
  };
};

export default connect(mapStateToProps)(CourseEditGroupContainer);
